// extracted by mini-css-extract-plugin
export default {"sp-background":"json-viewer_sp-background__70nD5","enrichment-viewer":"json-viewer_enrichment-viewer__z3SAa"};